import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import SwiperCore, { Pagination, Navigation, Lazy, Autoplay } from "swiper";
import { SwiperComponent } from "swiper/angular";
// install Swiper modules
SwiperCore.use([Lazy, Pagination, Navigation, Autoplay]);

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PartnersComponent implements OnInit {
  parameterValue;
  constructor(
    private _activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.parameterValue = "business";

    this._activatedRoute.params.subscribe((parameter) => {
      this.parameterValue = parameter.type;
    });
  }

}
